module.exports = __webpack_public_path__ + "img/img-search09.3840de88.jpg";